import _ from 'lodash';
import React from 'react';
import { serviceDescriptorsForAccount } from 'customer/data.js';
import { useQueryGetCustomerAccountMetadata } from 'customer/queries.js';
import * as b from 'react-bootstrap';

import { useProductModelContext } from 'hooks/product-model-context';
import { ACCOUNT_TYPES } from 'common/constants';

export const ServiceBlocks = ({ account }) => {
  const { query: detailsQuery } = useQueryGetCustomerAccountMetadata(account);
  const productModel = useProductModelContext();

  const serviceDescriptors = serviceDescriptorsForAccount(_.merge({}, account, detailsQuery?.data), productModel.products);
  if (!serviceDescriptors?.length && !detailsQuery.isLoading) {
    return (
      <span className="rsd-card__service-block-list">N/A</span>
    );
  }
  if ((!serviceDescriptors?.length && detailsQuery.isLoading) || productModel.status === 'loading') {
    return (
      <span className="rsd-card__service-block-list">
        <div className="rsd-card-inline-loading-indicator">
          <b.Spinner animation="border" variant="dark" size="sm" />
        </div>
      </span>
    );
  }
  return (
    <div className="d-flex flex-row flex-wrap gap-2">
      {_.map(serviceDescriptors, (serviceBlock) => {
        if (!serviceBlock || (account.type === ACCOUNT_TYPES.OPENSTACK_ENTERPRISE && serviceBlock === 'unspecified')) {
          return (
            <span className="rsd-card__service-block-list">N/A</span>
          );
        }
        return (
          <b.Badge
            bg="light"
            text="light"
            variant="light" key={serviceBlock}
          >
            {serviceBlock}
          </b.Badge>
        );
      })}
    </div>
  );
};
